// @ts-nocheck
import { get, post, patch, apiUrl } from "./utils/api";
import { buildVagaPayload } from "../../utils/functions";
import { buildQueryCandidato } from "../../utils/functions";
const API_URL = apiUrl;
/* ============================================================================
 * VAGAS
 * ========================================================================== */
/**
 * @summary Lista vagas com paginaÃ§Ã£o e filtros dinÃ¢micos.
 * @route GET /vagas
 * @param {GetVagasParams} [params] ParÃ¢metros de filtro/paginaÃ§Ã£o.
 * @returns {Promise<VagasResponse|Object>} Objeto com registros e metadados.
 * @example
 * const { registros } = await getVagas({ page: 1, limit: 20, titulo: "Motorista" });
 */
export const getVagas = async (params = {}) => {
    const url = `${API_URL}/vagas`;
    const qs = new URLSearchParams();
    // paginaÃ§Ã£o
    if (params.page !== undefined)
        qs.set("page", String(params.page));
    if (params.limit !== undefined)
        qs.set("limit", String(params.limit));
    // filtros conhecidos
    if (params.titulo)
        qs.set("titulo", params.titulo);
    if (params.descricao)
        qs.set("descricao", params.descricao);
    // necessitaCNH sÃ³ quando for 0 ou 1
    if (params.necessitaCNH === 0 || params.necessitaCNH === 1) {
        qs.set("necessitaCNH", String(params.necessitaCNH));
    }
    // demais filtros dinÃ¢micos (sem sobrescrever os jÃ¡ tratados)
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined &&
            value !== "" &&
            key !== "page" &&
            key !== "limit" &&
            key !== "titulo" &&
            key !== "descricao" &&
            key !== "necessitaCNH") {
            qs.set(key, String(value));
        }
    });
    const finalUrl = `${url}?${qs.toString()}`;
    const response = await get(finalUrl);
    return response?.data || response || {};
};
/**
 * GET /vagas/{id}
 * (nÃ£o substitui o getVagaById existente; Ã© sÃ³ uma nova funÃ§Ã£o utilitÃ¡ria)
 */
export const getVagaById = async (id) => {
    if (!id)
        throw new Error('ID da vaga Ã© obrigatÃ³rio');
    const url = `${API_URL}/vagas/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Cria uma nova vaga.
 * @route POST /vagas
 * @param {any} payload Corpo com os dados da vaga.
 * @returns {Promise<Object>} Vaga criada.
 * @example
 * await createVaga({ Titulo: "Backend", Salario: 9000, Ativo: true });
 */
export const createVaga = async (payload) => {
    const body = buildVagaPayload(payload, { partial: false });
    const url = `${API_URL}/vagas`;
    const response = await post(url, body);
    return response?.data || response || {};
};
/**
 * @summary Atualiza parcialmente uma vaga existente.
 * @route PATCH /vagas/{id}
 * @param {number|string} id ID da vaga.
 * @param {any} payload Campos a atualizar.
 * @returns {Promise<Object>} Vaga atualizada.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * await updateVaga(123, { Salario: 9500, Ativo: true });
 */
export const updateVaga = async (id, payload) => {
    if (!id)
        throw new Error("ID da vaga Ã© obrigatÃ³rio");
    const body = buildVagaPayload(payload, { partial: true });
    const url = `${API_URL}/vagas/${id}`;
    const response = await patch(url, body);
    return response?.data || response || {};
};
/**
 * @summary Encerra uma vaga (define Ativo = 0)
 * @route GET /vagas/encerrar-vaga/:id
 * @returns {Promise<any>} Resposta do backend (ex.: { message: 'Vaga desativada', result: { affectedRows: ... } })
 * @example
 * await encerrarVaga(6);
 */
export const encerrarVaga = async (id) => {
    if (!Number.isInteger(id) || id <= 0) {
        throw new Error('ID invÃ¡lido');
    }
    const url = `${API_URL}/vagas/encerrar-vaga/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Encerra uma vaga (define Ativo = 0)
 * @route GET /vagas/reabrir-vaga/:id
 * @returns {Promise<any>} Resposta do backend (ex.: { message: 'Vaga reaberta', result: { affectedRows: ... } })
 * @example
 * await encerrarVaga(6);
 */
export const reabrirVaga = async (id) => {
    if (!Number.isInteger(id) || id <= 0) {
        throw new Error('ID invÃ¡lido');
    }
    const url = `${API_URL}/vagas/reabrir-vaga/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/* ============================================================================
 * COMPLEMENTARES
 * ========================================================================== */
/**
 * @summary Lista complementares prontos para uso em selects (value/label).
 * @route GET /complementares
 * @param {string} [categoria] Filtra por categoria.
 * @returns {Promise<Array<{value:number,label:string,raw:any}>>}
 * @example
 * const opts = await getComplementares("regime");
 */
export const getComplementares = async (categoria) => {
    const qs = new URLSearchParams();
    if (categoria)
        qs.append("categoria", categoria);
    const url = `${API_URL}/complementares?${qs.toString()}`;
    const res = await get(url);
    const data = res?.data || res || {};
    const registros = data.registros || [];
    return registros.map((c) => ({
        value: c.id,
        label: c.Nome || String(c.id),
        raw: c,
    }));
};
/**
 * @summary Lista complementares com paginaÃ§Ã£o e filtros.
 * @route GET /complementares
 * @param {{page?:number,limit?:number,categoria?:string,regime?:string}} [params]
 * @returns {Promise<{registros:any[],totalRegistros:number,paginaAtual:number,quantidadePorPagina:number}>}
 * @example
 * const page = await getComplementaresPaged({ page: 1, limit: 50 });
 */
export const getComplementaresPaged = async (params = {}) => {
    const qs = new URLSearchParams();
    if (params.page !== undefined)
        qs.append("page", String(params.page));
    if (params.limit !== undefined)
        qs.append("limit", String(params.limit));
    if (params.categoria)
        qs.append("categoria", params.categoria);
    if (params.regime)
        qs.append("regime", params.regime);
    // default de limit = 50
    if (!qs.has("limit"))
        qs.append("limit", "50");
    const url = `${API_URL}/complementares?${qs.toString()}`;
    const response = await get(url);
    const data = response?.data || response || {};
    return {
        registros: Array.isArray(data.registros)
            ? data.registros
            : Array.isArray(data)
                ? data
                : [],
        totalRegistros: Number(data.totalRegistros ?? 0),
        paginaAtual: Number(data.paginaAtual ?? params.page ?? 1),
        quantidadePorPagina: Number(data.quantidadePorPagina ?? params.limit ?? 50),
    };
};
/**
 * @summary Busca um item complementar pelo ID.
 * @route GET /complementares/{id}
 * @param {number|string} id ID do complementar.
 * @returns {Promise<Object>} Registro encontrado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * const comp = await getComplementarById(5);
 */
export const getComplementarById = async (id) => {
    if (!id)
        throw new Error("ID do complementar Ã© obrigatÃ³rio");
    const url = `${API_URL}/complementares/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Cria um novo item complementar.
 * @route POST /complementares
 * @param {any} payload Corpo com { Categoria, Nome, ... }.
 * @returns {Promise<Object>} Complementar criado.
 * @example
 * await createComplementares({ Categoria: "Regime", Nome: "CLT" });
 */
export const createComplementares = async (payload) => {
    const url = `${API_URL}/complementares`;
    const response = await post(url, payload);
    return response?.data || response || {};
};
/**
 * @summary Atualiza parcialmente um item complementar.
 * @route PATCH /complementares/{id}
 * @param {number|string} id ID do complementar.
 * @param {any} payload Campos a atualizar.
 * @returns {Promise<Object>} Complementar atualizado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * await updateComplementares(7, { Nome: "Vale RefeiÃ§Ã£o" });
 */
export const updateComplementares = async (id, payload) => {
    if (!id)
        throw new Error("ID do complementar Ã© obrigatÃ³rio");
    const url = `${API_URL}/complementares/${id}`;
    const response = await patch(url, payload);
    return response?.data || response || {};
};
/* ============================================================================
 * BENEFÃCIOS
 * ========================================================================== */
/**
 * @summary Lista benefÃ­cios com paginaÃ§Ã£o e filtro por categoria.
 * @route GET /beneficios
 * @param {GetBeneficiosParams} [params] Filtros e paginaÃ§Ã£o.
 * @returns {Promise<BeneficiosResponse>}
 * @example
 * const res = await getBeneficios({ page:1, limit:50, categoria:"vale" });
 */
export const getBeneficios = async (params = {}) => {
    const qs = new URLSearchParams();
    if (params.page !== undefined)
        qs.append("page", String(params.page));
    if (params.limit !== undefined)
        qs.append("limit", String(params.limit));
    if (params.categoria)
        qs.append("categoria", params.categoria);
    if (!qs.has("limit"))
        qs.append("limit", "50");
    const url = `${API_URL}/beneficios?${qs.toString()}`;
    const response = await get(url);
    const data = response?.data || response || {};
    return {
        registros: Array.isArray(data.registros)
            ? data.registros
            : Array.isArray(data)
                ? data
                : [],
        totalRegistros: Number(data.totalRegistros ?? 0),
        paginaAtual: Number(data.paginaAtual ?? params.page ?? 1),
        quantidadePorPagina: Number(data.quantidadePorPagina ?? params.limit ?? 50),
    };
};
/**
 * @summary Busca um benefÃ­cio pelo ID.
 * @route GET /beneficios/{id}
 * @param {number|string} id ID do benefÃ­cio.
 * @returns {Promise<Object>} BenefÃ­cio encontrado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * const b = await getBeneficioById(10);
 */
export const getBeneficioById = async (id) => {
    if (!id)
        throw new Error("ID do beneficio Ã© obrigatÃ³rio");
    const url = `${API_URL}/beneficios/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Cria um novo benefÃ­cio.
 * @route POST /beneficios
 * @param {any} payload Corpo com { Categoria, Nome, ... }.
 * @returns {Promise<Object>} BenefÃ­cio criado.
 * @example
 * await createBeneficio({ Categoria: "Vale", Nome: "Vale RefeiÃ§Ã£o" });
 */
export const createBeneficio = async (payload) => {
    const url = `${API_URL}/beneficios`;
    const response = await post(url, payload);
    return response?.data || response || {};
};
/**
 * @summary Atualiza parcialmente um benefÃ­cio existente.
 * @route PATCH /beneficios/{id}
 * @param {number|string} id ID do benefÃ­cio.
 * @param {any} payload Campos a atualizar.
 * @returns {Promise<Object>} BenefÃ­cio atualizado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * await updateBeneficio(3, { Nome: "Vale AlimentaÃ§Ã£o" });
 */
export const updateBeneficio = async (id, payload) => {
    if (!id)
        throw new Error("ID do benefÃ­cio Ã© obrigatÃ³rio");
    const url = `${API_URL}/beneficios/${id}`;
    const response = await patch(url, payload);
    return response?.data || response || {};
};
/* ============================================================================
 * CANDIDATOS
 * ========================================================================== */
/**
 * @summary Lista candidatos com filtros, paginaÃ§Ã£o e ordenaÃ§Ã£o.
 * @route GET /candidatos
 * @param {CandidatosFilters} [filters] Filtros e ordenaÃ§Ã£o.
 * @param {number} [page=1] PÃ¡gina atual.
 * @param {number} [limit=20] Itens por pÃ¡gina.
 * @returns {Promise<CandidatosResponse>}
 * @example
 * const r = await getCandidatos({ search:"Maria", sortBy:"Nome", sortDir:"asc" }, 1, 50);
 */
export const getCandidatos = async (filters = {}, page = 1, limit = 20) => {
    const query = buildQueryCandidato({ ...filters, page, limit }, {
        dateKeys: ["validadeCnhInicio", "validadeCnhFim", "dataCriadoInicio", "dataCriadoFim"],
        boolKeys: ["somenteComCNH", "somenteComCurriculo", "incluirDeletados"],
    });
    const url = `${API_URL}/candidatos${query ? `?${query}` : ""}`;
    const response = await get(url);
    return (response?.data ||
        response || {
        registros: [],
        totalRegistros: 0,
        paginaAtual: page,
        quantidadePorPagina: limit,
    });
};
/**
 * @summary Busca um candidato pelo ID.
 * @route GET /candidatos/{id}
 * @param {number|string} id ID do candidato.
 * @returns {Promise<CandidatoDTO|Object>} Candidato encontrado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * const c = await getCandidatoById(42);
 */
export const getCandidatoById = async (id) => {
    if (!id)
        throw new Error("ID do candidato Ã© obrigatÃ³rio");
    const url = `${API_URL}/candidatos/${id}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Cria um novo candidato com eventuais anexos (one-shot).
 * @route POST /candidatos
 * @param {CreateCandidatoPayload|FormData} payload Objeto plano ou FormData.
 * @returns {Promise<Object>} Candidato criado.
 * @example
 * await createCandidato(formData);
 */
export const createCandidato = async (payload) => {
    const url = `${API_URL}/candidatos`;
    // Se jÃ¡ vier um FormData, envia direto:
    if (payload instanceof FormData) {
        const response = await post(url, payload); // nÃ£o setar Content-Type manualmente
        return response?.data || response || {};
    }
    // Caso contrÃ¡rio, monta o FormData a partir do objeto plano:
    const form = new FormData();
    const appendIf = (k, v) => {
        if (v !== undefined && v !== null && v !== "")
            form.append(k, v);
    };
    appendIf("Nome", payload.Nome);
    appendIf("Sobrenome", payload.Sobrenome);
    appendIf("CPF", payload.CPF);
    appendIf("Email", payload.Email);
    appendIf("IdVaga", String(payload.IdVaga));
    appendIf("NumeroLocalizacao", payload.NumeroLocalizacao);
    appendIf("NumeroTelefone", payload.NumeroTelefone);
    appendIf("Escolaridade", payload.Escolaridade);
    appendIf("CidadeNascimento", payload.CidadeNascimento);
    appendIf("EstadoNascimento", payload.EstadoNascimento);
    appendIf("PaisNascimento", payload.PaisNascimento);
    appendIf("CEPLocalizacao", payload.CEPLocalizacao);
    appendIf("EstadoLocalizacao", payload.EstadoLocalizacao);
    appendIf("CidadeLocalizacao", payload.CidadeLocalizacao);
    appendIf("BairroLocalizacao", payload.BairroLocalizacao);
    appendIf("RuaLocalizacao", payload.RuaLocalizacao);
    appendIf("ComplementoLocalizacao", payload.ComplementoLocalizacao);
    appendIf("NumeroCNH", payload.NumeroCNH);
    appendIf("CategoriaCNH", payload.CategoriaCNH);
    appendIf("ValidadeCNH", payload.ValidadeCNH);
    appendIf("PIS", payload.PIS);
    appendIf("experienciasProfissionais", payload.experienciasProfissionais);
    if (payload.ImgCNH)
        form.append("ImgCNH", payload.ImgCNH);
    if (payload.ImgCurriculo)
        form.append("ImgCurriculo", payload.ImgCurriculo);
    const response = await post(url, form);
    return response?.data || response || {};
};
/**
 * @summary Faz o download (via proxy backend) de CNH ou CurrÃ­culo de um candidato.
 * @route GET /candidatos/{id}/download?tipo=cnh|curriculo
 * @param {number|string} id ID do candidato.
 * @param {"cnh"|"curriculo"} tipo Tipo do arquivo.
 * @returns {Promise<void>} Dispara o download no navegador.
 * @throws {Error} Se o ID/tipo forem invÃ¡lidos ou a resposta nÃ£o for OK.
 * @example
 * await downloadCandidatoArquivo(42, "curriculo");
 */
export const downloadCandidatoArquivo = async (id, tipo) => {
    if (!id)
        throw new Error("ID do candidato Ã© obrigatÃ³rio");
    if (!["cnh", "curriculo"].includes(tipo))
        throw new Error("Tipo invÃ¡lido. Use 'cnh' ou 'curriculo'.");
    const url = `${API_URL}/candidatos/${id}/download?tipo=${tipo}`;
    const response = await fetch(url);
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`Erro ao baixar arquivo: ${response.status} - ${text}`);
    }
    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition") || "";
    const suggested = response.headers.get("x-suggested-filename") || "";
    const cdMatch = /filename\*?=(?:UTF-8''([^;]+)|"([^"]+)"|([^;]+))/i.exec(contentDisposition);
    const filenameFromCD = cdMatch
        ? decodeURIComponent(cdMatch[1] || cdMatch[2] || cdMatch[3] || "")
        : "";
    let filename = filenameFromCD || suggested;
    // Fallback: deriva pela MIME se nÃ£o veio nada
    if (!filename) {
        const ct = blob.type || "application/octet-stream";
        const map = {
            "application/pdf": ".pdf",
            "image/png": ".png",
            "image/jpeg": ".jpg",
            "image/jpg": ".jpg",
            "image/webp": ".webp",
            "image/gif": ".gif",
        };
        const ext = map[ct.toLowerCase()] || ".bin";
        filename = `${tipo}_${id}${ext}`;
    }
    const link = document.createElement("a");
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
};
/**
 * @summary Altera o status do candidato pelo ID.
 * @route PATCH /candidatos/{id}/visualizado
 * @param {number|string} id ID do candidato.
 * @returns {Promise<CandidatoDTO|Object>} Candidato encontrado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * const c = await statusVisualizado(42);
 */
export const statusVisualizado = async (id) => {
    if (!id)
        throw new Error("ID do candidato Ã© obrigatÃ³rio");
    const url = `${API_URL}/candidatos/${id}/visualizado`;
    const response = await patch(url);
    return response?.data || response || {};
};
/**
 * @summary Altera o favorito do candidato pelo ID.
 * @route PATCH /candidatos/{id}/favorito
 * @param {number|string} id ID do candidato.
 * @returns {Promise<CandidatoDTO|Object>} Candidato encontrado.
 * @throws {Error} Se o ID nÃ£o for informado.
 * @example
 * const c = await statusVisualizado(42);
 */
export const alterarFavorito = async (id) => {
    if (!id)
        throw new Error("ID do candidato Ã© obrigatÃ³rio");
    const url = `${API_URL}/candidatos/${id}/favorito`;
    const response = await patch(url);
    return response?.data || response || {};
};
/* ============================================================================
 * DASHBOARD
 * ========================================================================== */
/**
 * @summary Busca total de candidatos.
 * @route GET /dashboard/candidatos/total
 * @example
 * const c = await dashCandidatosTotal();
 */
export const dashCandidatosTotal = async () => {
    const url = `${API_URL}/dashboard/candidatos/total`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Busca total de candidatos de hoje.
 * @route GET /dashboard/candidatos/hoje
 * @example
 * const c = await dashCandidatosHoje();
 */
export const dashCandidatosHoje = async () => {
    const url = `${API_URL}/dashboard/candidatos/hoje`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Busca total de vagas de motoristas.
 * @route GET /dashboard/vagas/motoristas
 * @example
 * const c = await dashMotoristasVagas();
 */
export const dashMotoristasVagas = async () => {
    const url = `${API_URL}/dashboard/vagas/motoristas`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * @summary Busca total de vagas.
 * @route GET /dashboard/vagas/nao-motoristas
 * @example
 * const c = await dashNaoMotoristaVagas();
 */
export const dashNaoMotoristaVagas = async () => {
    const url = `${API_URL}/dashboard/vagas/nao-motoristas`;
    const response = await get(url);
    return response?.data || response || {};
};
/* ============================================================================
 * CEP (proxy backend)
 * ========================================================================== */
/**
 * @summary Consulta endereÃ§o por CEP via seu backend (proxy de CEP).
 * @route GET /pesquisa-cep/api/cep/{cep}
 * @param {string} cep CEP com ou sem mÃ¡scara (ex.: "01310-000" ou "01310000").
 * @returns {Promise<CepEndereco>} EndereÃ§o normalizado.
 * @throws {Error} Se CEP for invÃ¡lido (nÃ£o possuir 8 dÃ­gitos) ou a API falhar.
 * @example
 * const end = await buscarEnderecoPorCep("01310-000");
 */
export const buscarEnderecoPorCep = async (cep) => {
    if (!cep)
        throw new Error("CEP Ã© obrigatÃ³rio.");
    const digits = String(cep).replace(/\D/g, "");
    if (digits.length !== 8)
        throw new Error("CEP invÃ¡lido. Use 8 dÃ­gitos.");
    const url = `${API_URL}/pesquisa-cep/api/cep/${digits}`;
    const response = await fetch(url);
    if (!response.ok) {
        const text = await response.text().catch(() => "");
        if (response.status === 400)
            throw new Error("CEP invÃ¡lido.");
        if (response.status === 404)
            throw new Error("CEP nÃ£o encontrado.");
        if (response.status === 502)
            throw new Error("Erro ao consultar serviÃ§o externo de CEP.");
        throw new Error(`Erro ao consultar CEP: ${response.status} ${text}`);
    }
    const data = await response.json();
    return {
        cep: data.cep || `${digits.slice(0, 5)}-${digits.slice(5)}`,
        uf: data.uf || "",
        cidade: data.cidade || data.localidade || "",
        bairro: data.bairro || "",
        logradouro: data.logradouro || "",
        complemento: data.complemento || "",
        fonte: data.fonte || data._fonte || undefined,
    };
};
/* ============================================================================
 * GEMINI (proxy backend)
 * ========================================================================== */
/**
 * @summary Melhora um texto via backend (proxy Gemini).
 * @route POST /ai/improve-text
 * @param {string} texto Texto original a ser aprimorado.
 * @returns {Promise<{ improvedText: string }>} Texto reescrito de forma mais formal e didÃ¡tica.
 * @throws {Error} Se o texto for invÃ¡lido ou se o backend retornar erro.
 * @example
 * const { improvedText } = await melhorarTexto("preciso melhorar esse paragrafo para enviar ao cliente");
 * console.log(improvedText);
 * // â†’ "Preciso aprimorar este parÃ¡grafo antes de enviÃ¡-lo ao cliente."
 */
export const melhorarTexto = async (texto, config) => {
    if (!texto || typeof texto !== "string" || !texto.trim()) {
        throw new Error("O texto e obrigatorio para melhoria.");
    }
    const url = `${API_URL}/ai/improve-text`;
    try {
        const response = await post(url, { text: texto }, config);
        const data = response?.data || response || {};
        if (!data?.ok || !data.improvedText) {
            throw new Error("Resposta inesperada do servidor Gemini.");
        }
        return { improvedText: data.improvedText };
    }
    catch (err) {
        const status = err?.response?.status;
        if (status === 400)
            throw new Error("Texto invalido enviado ao servidor.");
        if (status === 401)
            throw new Error("Nao autorizado. Verifique seu token.");
        if (status === 500)
            throw new Error("Erro interno no servico do Gemini.");
        const message = err?.response?.data?.error || err?.message || "Erro ao melhorar texto.";
        throw new Error(message);
    }
};
